import { ReactNode } from 'react';

import Logo from 'components/logo';
import { Card, CardContent, CardHeader } from 'components/ui/card';

interface Props {
    children: ReactNode;
    withLogo?: boolean;
}

const AuthCard = ({ children, withLogo = false }: Props) => (
    // `!`: `cn` does not know `shadow-auth-card` is a shadow, so it cannot drop the card's own `shadow-xs`.
    <Card className="shadow-auth-card! w-full max-w-[440px] gap-8 [--card-spacing:--spacing(6)] sm:[--card-spacing:--spacing(10)]">
        {withLogo && (
            <CardHeader>
                <Logo href="https://crespect.com" target="_self" className="justify-self-center" />
            </CardHeader>
        )}
        <CardContent className="gap-0">{children}</CardContent>
    </Card>
);

export default AuthCard;
